import { normalizeSpot, type SpotIdentityWire } from '../components/RoomLayoutMap/spotKey';
import type { BookedSpot } from './bookedSpotNames';
import { getSpotPayloadForBookSpot } from './bookSpotReserveParams';
import type { FriendsSpotsReserveWireBody } from './reserveSpotContract';

/**
 * One slot from onFriendsSpotSelectionChange (member first); null = slot still empty. The CTA gate
 * and `buildFriendsSpotsReservePayload` share it, so both accept the full `RoomLayoutSpot` as well
 * as the lighter `{ spotName }` / `{ spot_name }` wire shapes.
 */
export type FriendsSpotSelectionEntry = (SpotIdentityWire & { spot_type_prefix?: string }) | null;

export function getFriendsSpotReserveName(selection: FriendsSpotSelectionEntry): string | null {
  // Loose check: hosts can hand us a sparse array whose holes read as undefined.
  if (selection == null) return null;
  const spotName = getSpotPayloadForBookSpot(normalizeSpot(selection));
  // Sent verbatim as `spot_name`, so a blank (whitespace-only) name never counts as selected.
  if (spotName === null || spotName.trim() === '') return null;
  return spotName;
}

export function buildFriendsSpotsReservePayload(
  selections: readonly FriendsSpotSelectionEntry[]
): FriendsSpotsReserveWireBody | null {
  if (selections.length === 0) return null;
  const spots: BookedSpot[] = [];
  for (const [guest, selection] of selections.entries()) {
    const spot_name = getFriendsSpotReserveName(selection);
    if (spot_name === null) return null;
    spots.push({ spot_name, guest });
  }
  return { spots };
}
